export const localizedContent = (answer, language) => {
    const translation = answer.translations.find((translation) => translation.language.toLowerCase() === language) || answer.translations.find((translation) => translation.language.toLowerCase() === 'en');

    if(translation){
        return translation.text;
    }
    else {
        return "[ERROR] Translation missing!";
    }
};